import React from 'react';

const Header = ({ onShowPage, activePage, toolCount = 524 }) => {
  return (
    <header>
      <div className="container">
        <div className="header-content">

          {/* Logo */}
          <div className="logo" onClick={() => onShowPage('directory')}>
            AI<span>Hub</span>
          </div>

          {/* Search */}
          <div className="search-container">
            <div className="search-wrapper">
              <svg
                className="search-icon"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
              <input
                type="text"
                id="searchInput"
                placeholder="Search 500+ AI tools..."
              />
            </div>
          </div>

          {/* Nav */}
          <nav className="header-nav">
            <a
              className={`nav-link ${activePage === 'blogs' ? 'active' : ''}`}
               href='/blogs'            >
              Blogs
            </a>
            <a
              className={`nav-link ${activePage === 'directory' ? 'active' : ''}`}
              href='/'
            >
              ✨ AI Directory
            </a>

            <a
              className={`nav-link ${activePage === 'features' ? 'active' : ''}`}
              href='/ai-features'
            >
              ✨ AI Features
            </a>

          </nav>

          {/* Stats */}
          <div className="stats">
            <div className="stat-item">
              <span className="stat-number" id="toolCount">{toolCount}</span>
              <span className="stat-label">Tools</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">38</span>
              <span className="stat-label">Categories</span>
            </div>
          </div>

        </div>
      </div>
    </header>
  );
};

export default Header;
